var map = {
	"./1.jpg": 727,
	"./10.jpg": 4087,
	"./2.jpg": 744,
	"./3.jpg": 5061,
	"./4.jpg": 9438,
	"./5.jpg": 7483,
	"./6.jpg": 9180,
	"./7.jpg": 9705,
	"./8.jpg": 5218,
	"./9.jpg": 6927,
	"./Anniversary.png": 6576,
	"./Anniversary/1713633715729.jpg": 1966,
	"./Anniversary/1713633715796.jpg": 1008,
	"./Birthday.png": 9295,
	"./Birthday/Birthday(1).jpg": 6577,
	"./Birthday/Birthday(13).jpg": 6478,
	"./Birthday/Birthday(14).jpg": 3175,
	"./Birthday/Birthday(15).jpg": 9588,
	"./Birthday/Birthday(17).jpg": 3890,
	"./Birthday/Birthday(19).jpg": 7304,
	"./Birthday/Birthday(2).jpg": 9960,
	"./Birthday/Birthday(3).jpg": 6619,
	"./Birthday/Birthday(5).jpg": 981,
	"./Birthday/Birthday(6).jpg": 6348,
	"./Birthday/Birthday(9).jpg": 2809,
	"./Birthday/New folder/Birthday(10).jpg": 7776,
	"./Birthday/New folder/Birthday(11).jpg": 339,
	"./Birthday/New folder/Birthday(12).jpg": 2750,
	"./Birthday/New folder/Birthday(16).jpg": 162,
	"./Birthday/New folder/Birthday(18).jpg": 3576,
	"./Birthday/New folder/Birthday(4).jpg": 6515,
	"./Birthday/New folder/Birthday(7).jpg": 1454,
	"./Birthday/New folder/Birthday(8).jpg": 9487,
	"./Black.png": 4983,
	"./Events_Image.png": 761,
	"./First-img.png": 1442,
	"./Home1.jpg": 7064,
	"./Second-img.png": 9950,
	"./ServicesPage.jpg": 97,
	"./ShreeLogo.png": 9676,
	"./Talent & Skill.png": 7367,
	"./TechieAnmolLogo.png": 5566,
	"./ThirdImg.png": 220,
	"./Wedding.png": 1446,
	"./Wedding/1713633715816.jpg": 9361,
	"./Wedding/1713633715872.jpg": 5167,
	"./Wedding/Snap.jpg": 6527,
	"./peakpx.jpg": 6381,
	"./snap1.jpg": 7159,
	"./teamwork.jpg": 8276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7326;